var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gact.is_h5),expression:"gact.is_h5"}],staticClass:"app-download",style:(_vm.info.css),attrs:{"data-info":"info"},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_vm._v("\n  "+_vm._s(_vm.info.appDownload.text || "下载芒果TV客户端")+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab79324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigUI/AppDownload.vue
// module id = null
// module chunks = 